/* Author: Dhanabalan.cs
* Class : AdminSettingsService
* Purpose: Calling Backend API Service
* API calls related to admin settings
*/

import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http.service';
import { AppConfig } from '../../../shared/services/app_config';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable, throwError } from 'rxjs';
import { environment } from "environments/environment";


@Injectable({
  providedIn: 'root',
})
export class AdminSettingsService {

  domainName = AppConfig.IP_Address;

  footerContent = "";
  copyrightMsg: BehaviorSubject<String>;

  constructor(private http: HttpService, private httpClient: HttpClient) {
    this.copyrightMsg = new BehaviorSubject(this.footerContent);
  }

  returnHeaders(id: String) {
    let headers = AppConfig.header_info;

    if (id) {
      headers = { ...headers, 'pageid': id };
    } else {
      headers = { ...headers, 'pageid': null };
    }
    return headers
  }
  /**
  * @param {String} msg
  * @memberof AdminSettingsService
  */
  changeCopyrightMsg(msg: String): void {
    this.copyrightMsg.next(msg);
  }

  /**
  * Update Maximul allowed version in admin>settings>content
  * @return 
  */
  updateVersionSettings(data: object, pageid?: String) {
    let headers = this.returnHeaders(pageid)

    return this.httpClient
      .post(this.domainName + 'admin/settings/update-version-settings/', data, { headers: headers });
  }

  /**
  * This is settings config api - triggered in HTML CONTENT
  * @return 
  */
  getAppEvents(id?: String) {
    let hea = this.returnHeaders(id)
    //1. To fetch Application Events
    let getApplicationEvents = this.httpClient.get(this.domainName + 'admin/settings/get-all-application-events/', { headers: hea });
    //2. to fetch Captured Events   
    let getCapturedEvents = this.httpClient.get(this.domainName + 'admin/settings/get-captured-events/', { headers: hea });
    return forkJoin(
      [getApplicationEvents, getCapturedEvents]
    );
  }

  /**
  * Update App Events in settings
  * @return 
  */
  updateAppEventsSettings(data: object, id?: String) {
    let hea = this.returnHeaders(id)
    return this.httpClient
      .post(this.domainName + 'admin/settings/update-app-events-capture/', data, { headers: hea });
  }

  /**
  * Update Copyright content in settings
  * @return 
  */
  updateCopyRightContentSettings(data: object, id?: String) {
    let hea = this.returnHeaders(id)
    return this.httpClient
      .post(this.domainName + 'admin/settings/update-copyright-content/', data, { headers: hea });
  }
  /**
  * Get Copyright content in admin settings page
  * @return 
  */
  getCopyRightContentSettings() {
    return this.httpClient.get(this.domainName + 'admin/settings/get-copyright-content/');
  }
  getForceResetPasswordValidity(id?: String) {
    let headers = this.returnHeaders(id)

    return this.httpClient.get(this.domainName + 'admin/settings/get-force-reset-password-validity/', { headers: headers });
  }
  updateForceResetPasswordValidity(data: object, id?: String) {
    let headers = this.returnHeaders(id)
    return this.httpClient
      .post(this.domainName + 'admin/settings/update-force-reset-password-validity/', data, { headers: headers });
  }

  getLmsSettings(id?: String) {
    let hea = this.returnHeaders('4201')
    return this.httpClient.get(this.domainName + 'admin/settings/get-lms-settings/', { headers: hea });
  }
  saveLmsSettings(data: object, id?: String) {
    let hea = this.returnHeaders(id)
    return this.httpClient
      .post(this.domainName + 'admin/settings/save-lms-settings/', data, { headers: hea });
  }

  deleteLmsSettings(id?: String) {
    let hea = this.returnHeaders(id)
    return this.httpClient.delete(this.domainName + 'admin/settings/delete-lms-settings/', { headers: hea });
  }
getTenantInfobyDomain(domainName: string) {
    let hea = this.returnHeaders('4201')

  const payload = { domainName  };
  const apiUrl = environment.production 
    ? `${window.location.origin}/superadmin/tenantfetch/get-tenant-data`
    : `http://localhost:3009/superadmin/tenantfetch/get-tenant-data`;
console.log(apiUrl)
  return this.httpClient.post(apiUrl, payload,{ headers: hea });
 
}

}